import React, { FC, useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../..";
import PHCIcon from "./PHCIcon/PHCIcon";
import NotificationIcon from "./NotificationIcon/NotificationIcon";
import UserIcon from "./UserIcon/UserIcon";
import styles from "./Header.module.scss";

const Header: FC = () => {
  const { store } = useContext(Context);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState<boolean>(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState<boolean>(false);
  const userDropdownRef = useRef<HTMLDivElement | null>(null);
  const notificationDropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  const handleUserClick = () => setIsUserDropdownOpen(!isUserDropdownOpen);
  const handleNotificationClick = () => setIsNotificationDropdownOpen(!isNotificationDropdownOpen);

  const handleClickOutside = (event: MouseEvent) => {
    if (userDropdownRef.current && !userDropdownRef.current.contains(event.target as Node)) {
      setIsUserDropdownOpen(false);
    }
    if (notificationDropdownRef.current && !notificationDropdownRef.current.contains(event.target as Node)) {
      setIsNotificationDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLinkClick = (path: string) => {
    navigate(path);
    setIsUserDropdownOpen(false);
    setIsNotificationDropdownOpen(false);
  };

  return (
    <header className={styles['page-header']}>
      <PHCIcon />
      {store.isAuth ? (
        <div className={styles["page-header__block"]}>
          <div className={styles["page-header__divider"]} ref={notificationDropdownRef}>
            <NotificationIcon onClick={handleNotificationClick} />
            {isNotificationDropdownOpen && (
              <div className={styles['page-header__dropdown']}>
                {/* Тут вміст дропдаун-меню з повідомленнями */}
              </div>
            )}
          </div>
          <div className={styles["page-header__divider"]} ref={userDropdownRef}>
            <UserIcon onClick={handleUserClick} />
            {isUserDropdownOpen && (
              <div className={styles['page-header__dropdown']}>
                {/* <Link className={styles["page-header__dropdown-item"]} to="/edit-profile" onClick={() => handleLinkClick("/edit-profile")}>Редагувати профіль</Link> */}
                <Link className={styles["page-header__dropdown-item"]} to="/certifications/user" onClick={() => handleLinkClick("/certifications/user")}>Мої заявки</Link>
                <Link className={styles["page-header__dropdown-item"]} to="/" onClick={(e) => { e.preventDefault(); store.logout(); handleLinkClick("/"); }}>Вийти</Link>
              </div>
            )}
          </div>
        </div>
      ) : (
        <Link className={styles['page-header__link']} to="/login">Увійти</Link>
      )}
    </header>
  );
};

export default observer(Header);
